import { useHeaderContext } from '@jouzen/ecom-components/layout';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { useEffect } from 'react';

const useHardwarePDPHeaderAnimation = ({
  isCarouselInView,
}: {
  isCarouselInView?: boolean;
}): void => {
  const { setFadeActions, setFadeOuraLogo } = useHeaderContext()!;

  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (latest > 10) {
      setFadeActions(true);
    } else {
      setFadeActions(false);
    }
  });

  useEffect(() => {
    if (!isCarouselInView) {
      setFadeOuraLogo(true);
    } else {
      setFadeOuraLogo(false);
    }
  }, [isCarouselInView, setFadeOuraLogo]);
};

export default useHardwarePDPHeaderAnimation;
